import { useTranslation } from "react-i18next";
import { Combobox } from "../ui/combobox";
import { DatePicker } from "../ui/date-picker";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import MultipleSelectorWithSearch from "../ui/multiple-selector-with-search";
import { Textarea } from "../ui/textarea";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "../ui/hover-card";
import { InfoIcon } from "lucide-react";
import { useState } from "react";

export function MetatdataInput({onChange, metadata, metadataSchema, inputChecked}) {
  const { t } = useTranslation();
  const [metadataState, setMetadataState] = useState(metadata || {});
  const getInputByType = (type, key, options = [], value, required = false) => {
    if (type === "select_api_search") {
      return (
        <div className="pb-2">
          <MultipleSelectorWithSearch
            className="min-h-12"
            badgeClassName="bg-emerald-100 text-black"
            placeholder={key}
            value={metadataState[key]}
            label={t("bills:contract_id")}
            onChange={(newValue) => {
              if (newValue) {
                const new_update = {
                  ...metadataState,
                  [key]: newValue,
                };
                setMetadataState(new_update);
                if (onChange) onChange(new_update);
              }
            }}
            fetchOption={value["fetchOption"]}
            error={inputChecked && required && !metadataState[key]}
            errorMessage={t("empty_data_invalid")}
          />
        </div>
      );
    }

    if (type === "select") {
      return (
        <div className="pb-2">
          <Combobox
            key={metadataState[key]?.value}
            value={metadataState[key]}
            label={t(key)}
            placeholder={key}
            errorMessage={t("empty_data_invalid")}
            options={options}
            onChange={(newValue) => {
              if (newValue) {
                const new_update = {
                  ...metadataState,
                  [key]: newValue,
                };
                setMetadataState(new_update);
                if (onChange) onChange(new_update);
              }
            }}
            error={!metadataState[key]}
          />
        </div>
      );
    }
    if (type === "date") {
      return (
        <div className="pb-2">
          <DatePicker
            date={metadataState[key]}
            defaultMonth={new Date()}
            setDate={(e) => {
              const new_update = {
                ...metadataState,
                [key]: e,
              };
              setMetadataState(new_update);
              if (onChange) onChange(new_update);
            }}
            label={key}
          />
        </div>
      );
    }
    if (type === "input") {
      return (
        <div className="pb-2">
          <div className="flex items-center">
            <Label>{value.label || t(key)}</Label>
            {value.hint && (
              <HoverCard>
                <HoverCardTrigger>
                  <InfoIcon className="h-5 ml-2" />
                </HoverCardTrigger>
                <HoverCardContent>
                  <span>{value.hint}</span>
                </HoverCardContent>
              </HoverCard>
            )}
          </div>
          <Input
            value={metadataState[key]}
            onChange={(e) => {
              const new_update = {
                ...metadataState,
                [key]: e.target.value,
              };
              setMetadataState(new_update);
              if (onChange) onChange(new_update);
            }}
          />
        </div>
      );
    }
    if (type === "text") {
      return (
        <div className="pb-2">
          <div className="flex items-center">
            <Label>{value.label || t(key)}</Label>
            {value.hint && (
              <HoverCard>
                <HoverCardTrigger>
                  <InfoIcon className="h-5 ml-2" />
                </HoverCardTrigger>
                <HoverCardContent>
                  <span>{value.hint}</span>
                </HoverCardContent>
              </HoverCard>
            )}
          </div>
          <Textarea
            value={metadataState[key]}
            className="resize-none"
            onChange={(e) => {
              const new_update = {
                ...metadataState,
                [key]: e.target.value,
              };
              setMetadataState(new_update);
              if (onChange) onChange(new_update);
            }}
          />
        </div>
      );
    }
  };
  if (!metadataSchema) {
    return <></>;
  }
  return Object.entries(metadataSchema).map(([key, value]) =>
    getInputByType(value.type, key, value.options ?? [], value),
  );
}
